const defaultAppComponentsData = require("../../../src/vue/appComponents");

const tuskAppComponents = {
    PromotionsItems: () => import('./components/pages/parts/target/PromotionsItems.vue'),
    PlatformsItems: () => import('./components/pages/parts/target/PlatformsItems.vue'),
    PromotionsPopups: () => import('./components/popups/PromotionsPopups.vue'),
    CatalogBarWithProviderFilter: () => import('./components/CatalogBarWithProviderFilter.vue'),
    SearchCatalogBar: () => import('./components/layout/SearchCatalogBar.vue'),
    Register: () => import('./components/signIn/Register.vue'),
};

const tuskEntryPointComponents = {
    TheFooter: './themes/tusk/modules/components/layout/TheFooter.vue',
};

let appComponents = Object.assign(defaultAppComponentsData.appComponents, tuskAppComponents);

let entryPointComponents = Object.assign(defaultAppComponentsData.entryPointComponents, tuskEntryPointComponents);

module.exports = {
    appComponents,
    entryPointComponents,
};